import Store from 'lightningjs-redux';
import { getSideGlassContent } from '../../../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    shouldBeInvokedOnConnect: true,
    selector: getSideGlassContent,
    callback: value => {
      instance.data = value;
    },
  },
];

export default Store.control(mapControllers);
